export default __webpack_public_path__ + "static/media/decryptLOGO.5a48cc49.png";